<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tcustomers}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:tcustomers:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tcustomers:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="leadsName" label="用户姓名" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="leadsTel" label="手机号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="age" label="年龄" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pageName" label="page名字" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="componentId" label="城市ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="componentName" label="城市名" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="leadsId" label="线索id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="clickId" label="广告点击id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="accountId" label="广告主id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="accountType" label="账号类型" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="advertiserId" label="广告主ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="wechatAppid" label="微信账户APPID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="agencyId" label="服务商id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="agencyName" label="服务商名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="wechatSpid" label="微信服务商id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="campaignId" label="推广计划id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="campaignName" label="推广计划名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="adgroupId" label="广告组id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="adgroupName" label="广告组名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creativeId" label="创意ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creativeName" label="创意名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="adId" label="广告创意ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="adName" label="投放端创意ID对应的名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="adcreativeId" label="广告创意ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="adcreativeName" label="广告创意名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="pageId" label="落地页id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pageUrl" label="落地页url" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="leadsType" label="线索类型" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="leadsTags" label="线索标签" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="leadsSource" label="线索来源" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="leadsPotentialScore" label="系统评分" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="leadsTouchTag" label="线索接通状态" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="leadsFollowTag" label="线索状态" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="telLocation" label="号码归属地" header-align="center" align="center"></el-table-column>
        <el-table-column prop="leadsArea" label="所在地" header-align="center" align="center"></el-table-column>
        <el-table-column prop="leadsEmail" label="邮箱" header-align="center" align="center"></el-table-column>
        <el-table-column prop="leadsQq" label="qq号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="leadsWechat" label="微信号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="leadsGender" label="性别" header-align="center" align="center"></el-table-column>
        <el-table-column prop="nationality" label="国籍" header-align="center" align="center"></el-table-column>
        <el-table-column prop="workingYears" label="工作年限" header-align="center" align="center"></el-table-column>
        <el-table-column prop="profession" label="职业" header-align="center" align="center"></el-table-column>
        <el-table-column prop="idNumber" label="身份证号码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="address" label="详细地址" header-align="center" align="center"></el-table-column>
        <el-table-column prop="leadsCreateTime" label="线索入库时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="leadsActionTime" label="线索提交时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="shopName" label="门店名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="shopAddress" label="门店地址" header-align="center" align="center"></el-table-column>
        <el-table-column prop="callMiddleNum" label="智能电话中间号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="callConsumerHotline" label="客服电话" header-align="center" align="center"></el-table-column>
        <el-table-column prop="callTouchTag" label="接通状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="callDuration" label="通话时长" header-align="center" align="center"></el-table-column>
        <el-table-column prop="callRecordUrl" label="通话录音链接" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bundle" label="bundle" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:tcustomers:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:tcustomers:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tcustomers-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/tcustomers/page',
        getDataListIsPage: true,
        exportURL: '/sys/tcustomers/export',
        deleteURL: '/sys/tcustomers',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
